export default __webpack_public_path__ + "static/media/home-marketing-agency-bg-img-05.84d8fa46.jpg";